/**
 * @file
 * loader script.
 */

(function loaderScript($, Drupal) {
  'use strict';

  Drupal.behaviors.loader = {
    attach: function (context) {

      // Implicit throbber color.
      var color = 'green';

      // In case blog search overlay is active, set the throbber color to white.
      if ($('body.blog-search-active').length > 0) {
        color = 'white';
      }

      // Define the pitnerest throbber.
      var $pin_loader = '<div class="src-Box-Box---box---bpMa_ src-Box-Box---xs-flex---1TEXs justify-around overflow-hidden"><div class="src-Spinner-Spinner---icon---3HUbA block"><svg class="src-Icon-Icon---icon---3Goc6 ' + color + ' block" height="40" width="40" viewBox="0 0 16 16" aria-label="Example spinner" role="img"><title>Example spinner</title><path d="M10 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M6 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0"></path></svg></div></div>';

      // Execute the default throbber replace with pin styled one.
      var $drupal_loader = $('.ajax-progress.ajax-progress-fullscreen');
      $drupal_loader.html($pin_loader);

      var $hccf_loader = $('.webform-submission-help-center-contact-form-form .ajax-progress.ajax-progress-throbber', context);
      $hccf_loader.html($pin_loader);
    }
  };
}(jQuery, Drupal));
